import { render, staticRenderFns } from "./basic_info.vue?vue&type=template&id=049a3984&scoped=true"
import script from "./basic_info.vue?vue&type=script&lang=js"
export * from "./basic_info.vue?vue&type=script&lang=js"
import style0 from "./basic_info.vue?vue&type=style&index=0&id=049a3984&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049a3984",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049a3984')) {
      api.createRecord('049a3984', component.options)
    } else {
      api.reload('049a3984', component.options)
    }
    module.hot.accept("./basic_info.vue?vue&type=template&id=049a3984&scoped=true", function () {
      api.rerender('049a3984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/commerce_sabbatical/form/components/basic_info.vue"
export default component.exports